/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TaskModel
 */
export interface TaskModel {
    /**
     * 
     * @type {Array<number>}
     * @memberof TaskModel
     */
    consecutiveFailures?: Array<number>;
    /**
     * 
     * @type {Array<Date>}
     * @memberof TaskModel
     */
    executionTime?: Array<Date>;
    /**
     * 
     * @type {Date}
     * @memberof TaskModel
     */
    lastFailure?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TaskModel
     */
    lastHeartbeat?: Date;
    /**
     * 
     * @type {Array<Date>}
     * @memberof TaskModel
     */
    lastSuccess?: Array<Date>;
    /**
     * 
     * @type {Array<boolean>}
     * @memberof TaskModel
     */
    picked?: Array<boolean>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TaskModel
     */
    pickedBy?: Array<string>;
    /**
     * 
     * @type {Array<any>}
     * @memberof TaskModel
     */
    taskData?: Array<any>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TaskModel
     */
    taskInstance?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TaskModel
     */
    taskName?: string;
    /**
     * 
     * @type {number}
     * @memberof TaskModel
     */
    version?: number;
}

/**
 * Check if a given object implements the TaskModel interface.
 */
export function instanceOfTaskModel(value: object): value is TaskModel {
    return true;
}

export function TaskModelFromJSON(json: any): TaskModel {
    return TaskModelFromJSONTyped(json, false);
}

export function TaskModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskModel {
    if (json == null) {
        return json;
    }
    return {
        
        'consecutiveFailures': json['consecutiveFailures'] == null ? undefined : json['consecutiveFailures'],
        'executionTime': json['executionTime'] == null ? undefined : json['executionTime'],
        'lastFailure': json['lastFailure'] == null ? undefined : (new Date(json['lastFailure'])),
        'lastHeartbeat': json['lastHeartbeat'] == null ? undefined : (new Date(json['lastHeartbeat'])),
        'lastSuccess': json['lastSuccess'] == null ? undefined : json['lastSuccess'],
        'picked': json['picked'] == null ? undefined : json['picked'],
        'pickedBy': json['pickedBy'] == null ? undefined : json['pickedBy'],
        'taskData': json['taskData'] == null ? undefined : json['taskData'],
        'taskInstance': json['taskInstance'] == null ? undefined : json['taskInstance'],
        'taskName': json['taskName'] == null ? undefined : json['taskName'],
        'version': json['version'] == null ? undefined : json['version'],
    };
}

export function TaskModelToJSON(json: any): TaskModel {
    return TaskModelToJSONTyped(json, false);
}

export function TaskModelToJSONTyped(value?: TaskModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'consecutiveFailures': value['consecutiveFailures'],
        'executionTime': value['executionTime'],
        'lastFailure': value['lastFailure'] == null ? value['lastFailure'] : value['lastFailure'].toISOString(),
        'lastHeartbeat': value['lastHeartbeat'] == null ? value['lastHeartbeat'] : value['lastHeartbeat'].toISOString(),
        'lastSuccess': value['lastSuccess'],
        'picked': value['picked'],
        'pickedBy': value['pickedBy'],
        'taskData': value['taskData'],
        'taskInstance': value['taskInstance'],
        'taskName': value['taskName'],
        'version': value['version'],
    };
}

